exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#document-viewer[data-v-22866750]{-webkit-box-shadow:0 10px 48px rgba(30,107,174,.1),0 1px 1px rgba(255,248,254,.61);box-shadow:0 10px 48px rgba(30,107,174,.1),0 1px 1px rgba(255,248,254,.61)}", ""]);

// exports
